/**
 * Scroll Animations
 * IntersectionObserver-based fade-in + parallax effects.
 * Matches hooks/use-scroll-animation.ts
 *
 * Init defers to idle: these are decorative effects and the IO scan over
 * every .scroll-fade-up element shouldn't compete with LCP/TBT.
 */
(function () {
  'use strict';

  var rIC = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
  rIC(init, { timeout: 2000 });

  function init() {
  /* --- Fade-up on scroll --- */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.scroll-fade-up').forEach(function (el) {
    observer.observe(el);
  });

  /* --- Parallax on scroll --- */
  var parallaxEls = document.querySelectorAll('.parallax-fruit[data-parallax-speed]');
  if (parallaxEls.length > 0) {
    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;
      parallaxEls.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
        var rect = el.getBoundingClientRect();
        var centerY = rect.top + rect.height / 2 + scrollY;
        var offset = (scrollY - centerY + window.innerHeight / 2) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }
  }
})();
